/** Display only: an ordinal-only or unnamed Structure node remains valid source data. */
export function structureNodeDisplayLabel(node, fallback = "未命名目录项") {
    return [node.ordinal?.rawLabel.trim(), node.title.trim()].filter(Boolean).join(" ") || fallback;
}
//# sourceMappingURL=structure-node-label.js.map